import { cleanName } from '../../../common/utils/text';

// Client-side validation mirroring api-reference/admin-labs.md.
const MAX_NAME = 120;
const MAX_LOCATION = 255;

export function validateLab(form) {
    const errors = {};
    const name = cleanName(form.name);
    if (!name) errors.name = 'El nombre es obligatorio.';
    else if (name.length > MAX_NAME) errors.name = `Máximo ${MAX_NAME} caracteres.`;
    if (form.location && form.location.trim().length > MAX_LOCATION) {
        errors.location = `Máximo ${MAX_LOCATION} caracteres.`;
    }
    return errors;
}
